import React from 'react';

/**
 * Веб-заглушка нативного плеера записи.
 *
 * На вебе запись рисует сам `RoomRecordingPlayer` обычным `<video controls>` и
 * до этого компонента не доходит. Файл нужен, чтобы веб-бандлер разрешил импорт
 * и НЕ втянул `expo-video` — вся нативная реализация живёт в `.native`-близнеце.
 */
export const RoomRecordingVideo: React.FC<{
  playbackUrl: string | null;
  posterUri?: string | null;
  height?: number;
  /** CORE-1383 — в записи только звук; см. `.native`-близнец. */
  audioOnly?: boolean;
}> = () => null;

export default RoomRecordingVideo;
